
import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationManager } from 'Components/Notifications';
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { useDownload } from 'Core/hooks';

//Components
import { NotificationContainer } from "Components/Notifications";
import {
    TabContainer,
    Button,
    Modal,
    Tabs,
    Pill,
} from "@gpstrackit/gtc-react-controls";
import PillDownload from "Components/Pill";
//Actions
import {
    maintenanceMEDDeleteAttachments,
    maintenanceMEDEntityDetails,
    maintenanceMEDUpdateEntity,
    openModalEntityDetails,
    tabNumber,
    reset,
} from './redux/slice';
import {
    openModalScheduleMaintenanceServiceUnit,
    openModalCreateEditMaintenanceService,
    openModalScheduleDriverTasks,
} from 'Redux/actions';
const EntityDetails = (props) => {

    const { disableDelete, disableEdit, refresh } = props
    const { messages } = useIntl()
    const download = useDownload();
    const dispatch = useDispatch();

    const location = useLocation();

    //Local States
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [currentAttachment, setCurrentAttachment] = useState(null);
    const [currentAttachmentTitle, setCurrentAttachmentTitle] = useState(null);
    const [currentSuscriber, setCurrentSuscriber] = useState(null);

    //Redux States
    const {
        deleteAttachments: deleteAttachmentsResponse,
        loadingDeleteAttachments,
        loadingUpdateDetail,
        loadingDetail,
        updateDetail,
        entityTitle,
        entityName,
        numberTab,
        entityId,
        detail,
        error,
        open,
    } = useSelector(state => state.maintenanceEntityDetailsRedux);

    useEffect(() => {
        if (open && !loadingUpdateDetail && updateDetail) {
            dispatch(maintenanceMEDEntityDetails({ entityId, entityName, numberTab, entityTitle }));
            NotificationManager.success(
                messages['success'],
                messages['deleteSubscriber_success'],
                3000,
                null,
                null,
                'success'
            );
            dispatch(reset({ "updateDetail": null }));
            if (entityName === "MaintenanceService") {
                refresh && refresh();
            } else if (entityName === "DriverScheduledTask") {
                refresh && refresh();
            } else if (entityName === "MaintenanceServiceUnit") {
                refresh && refresh();
            }
        }
    }, [updateDetail, open]);

    useEffect(() => {
        if (open && !loadingDeleteAttachments && deleteAttachmentsResponse) {
            dispatch(maintenanceMEDEntityDetails({ entityId, entityName, numberTab, entityTitle }));
            NotificationManager.success(
                messages['success'],
                messages['deleteAttachment_success'],
                3000,
                null,
                null,
                'success'
            );
            dispatch(reset({ "deleteAttachments": null }));
            if (entityName === "MaintenanceService") {
                refresh && refresh();
            } else if (entityName === "DriverScheduledTask") {
                refresh && refresh();
            } else if (entityName === "MaintenanceServiceUnit") {
                refresh && refresh();
            }
        }
    }, [deleteAttachmentsResponse, open])

    useEffect(() => {
        if (open) dispatch(maintenanceMEDEntityDetails({ entityId, entityName }))
    }, [open])

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }));
        }
    }, [error])

    const Container = (props) => (
        <div style={{ margin: 0, padding: "0px 12px" }}>
            {props.children}
        </div>
    )

    const handleClose = () => {
        dispatch(reset());
        dispatch(openModalEntityDetails(false))
    }

    const handleEdit = () => {
        dispatch(openModalEntityDetails(false))
        if (entityName === "MaintenanceService") {
            dispatch(openModalCreateEditMaintenanceService(detail.id));
        } else if (entityName === "MaintenanceServiceUnit") {
            dispatch(openModalScheduleMaintenanceServiceUnit({ open: true, id: detail.id }))
        } else if (entityName === "DriverScheduledTask") {
            dispatch(openModalScheduleDriverTasks({ open: true, id: detail.id }));
        }
    }

    const handleSubscribers = (id, contact) => {
        setCurrentSuscriber(id);
        setOpenModalDelete(true);
        setCurrentAttachmentTitle(contact);
    }

    const handleAttachment = (id, originalName) => {
        let fileIds = [...detail.fileIds];
        let file = fileIds.filter((item) => item !== id);
        setCurrentAttachmentTitle(originalName);
        setCurrentAttachment(file);
        setOpenModalDelete(true);
    }

    const handleDeleteAttachmentSubmit = () => {
        setOpenModalDelete(false);
        if (numberTab === 0) dispatch(maintenanceMEDUpdateEntity({ id: currentSuscriber }));
        else dispatch(maintenanceMEDDeleteAttachments({ id: detail.id, files: currentAttachment, entityName }));
    }

    const handleCloseDelete = () => setOpenModalDelete(false);

    const dispatchTabNumber = (tabN) => {
        dispatch(tabNumber({ numberTab: tabN }))
    }
    
    return (
        <Fragment>
            {
                !openModalDelete &&
                <Modal
                    title={entityTitle}
                    hasHeader={false}
                    open={open}
                    handleClose={handleClose}
                    position="right"
                    size="small"
                    loading={loadingUpdateDetail || loadingDetail || loadingDeleteAttachments}
                    footer={(
                        <div>
                            <Button
                                variant={entityName === "DriverScheduledTaskLog" ? "primary" : "secondary"}
                                onClick={() => handleClose()}
                                style={{ marginRight: "5px" }}
                            >
                                {messages["cancel"]}
                            </Button>

                            {!disableEdit && entityName !== "DriverScheduledTaskLog" &&
                                <Button
                                    variant="primary"
                                    onClick={() => handleEdit()}
                                >
                                    {messages["edit"]}
                                </Button>
                            }
                        </div>
                    )}
                >
                    <div style={{ padding: "0 10px" }}>
                        {
                            entityName !== "DriverScheduledTaskLog" ? (
                                <Tabs
                                    tab={numberTab}
                                    style={{ marginTop: "18px" }}
                                    onChange={TabNum => dispatchTabNumber(TabNum)}
                                >
                                    <TabContainer label={messages["entityDetails_subscribers_label"]} index={0}>
                                        <Container>
                                            {detail && detail.subscribers && (
                                                <Fragment>
                                                    {detail.subscribers.length > 0 ? detail.subscribers.map((alert, index) => {
                                                        let contact = alert.contact ? alert.contact.title : "";
                                                        if (!contact) {
                                                            return <span key={index} />
                                                        }
                                                        let currentContact = contact
                                                        let alerts = [];
                                                        if (alert.alert) alerts.push(messages["vehicleDetailView_reminder"]);
                                                        if (alert.alertBefore) alerts.push(messages["vehicleDetailView_dueNow"]);
                                                        if (alert.alertAfter) alerts.push(messages["vehicleDetailView_pastDue"]);
                                                        contact += alerts.length ? `: ${alerts.join(", ")}` : "";
                                                        return (
                                                            <Pill
                                                                key={index}
                                                                size="full"
                                                                textField="name"
                                                                item={{ label: contact, color: '#66bb6a' }}
                                                                icon="close"
                                                                onClickIcon={() => handleSubscribers(alert.id, currentContact)}
                                                                disabled={disableDelete}
                                                                style={{ marginBottom: 5 }}
                                                            />
                                                        )
                                                    }) : !loadingDetail && <p style={{ margin: 0 }}>{messages["entityDetails_subscribersNotFound"]}</p>}

                                                </Fragment>
                                            )}
                                        </Container>
                                    </TabContainer>
                                    <TabContainer label={messages["entityDetails_subscribers_notes"]} index={1}>
                                        <Container>
                                            {detail && detail.notes ? (
                                                <p style={{ margin: 0, wordWrap: "break-word" }}>{detail.notes} </p>
                                            ) : !loadingDetail && <p style={{ margin: 0 }}>{messages["entityDetails_notesNotFound"]}</p>}
                                        </Container>
                                    </TabContainer>
                                    <TabContainer label={messages["entityDetails_subscribers_attachments"]} index={2}>
                                        <Container>
                                            {detail && detail.files && detail.files.length > 0 ? detail.files.map((file, key) => {
                                                const { id, originalName, repositoryCode, fileKey } = file
                                                const tempPill = {
                                                    id,
                                                    label: originalName,
                                                    repositoryCode,
                                                    fileKey,
                                                    color: '#66bb6a'
                                                }
                                                return (
                                                    <PillDownload
                                                        key={key}
                                                        item={{
                                                            id,
                                                            originalName,
                                                            repositoryCode,
                                                            fileKey
                                                        }}
                                                        textFieild="originalName"
                                                        colorField="color"
                                                        isDownload
                                                        onClose={() => handleAttachment(id, originalName)}
                                                        noDelete={entityName === "DriverScheduledTaskLog"}
                                                    />

                                                )
                                            }) : !loadingDetail && <p style={{ margin: 0 }}>{messages["entityDetails_attachmentsNotFound"]}</p>}
                                        </Container>
                                    </TabContainer>
                                </Tabs>
                            ) :
                                (
                                    <Tabs
                                        tab={numberTab}
                                        style={{ marginTop: "18px" }}
                                        onChange={TabNum => dispatchTabNumber(TabNum)}
                                    >
                                        <TabContainer label={messages["entityDetails_subscribers_notes"]} index={0}>
                                            <Container>
                                                {detail && detail.notes ? (
                                                    <p style={{ margin: 0, wordWrap: "break-word" }}>{detail.notes} </p>
                                                ) : !loadingDetail && <p style={{ margin: 0 }}>{messages["entityDetails_notesNotFound"]}</p>}
                                            </Container>
                                        </TabContainer>
                                        <TabContainer label={messages["entityDetails_subscribers_attachments"]} index={1}>
                                            <Container>
                                                {detail && detail.files && detail.files.length > 0 ? detail.files.map((file, key) => {
                                                    const { id, originalName, repositoryCode, fileKey } = file
                                                    const tempPill = {
                                                        id,
                                                        label: originalName,
                                                        repositoryCode,
                                                        fileKey,
                                                        color: '#66bb6a'
                                                    }
                                                    return (
                                                        <PillDownload
                                                            key={key}
                                                            item={{
                                                                id,
                                                                originalName,
                                                                repositoryCode,
                                                                fileKey
                                                            }}
                                                            textFieild="originalName"
                                                            colorField="color"
                                                            isDownload
                                                            onClose={() => handleAttachment(id, originalName)}
                                                            noDelete={entityName === "DriverScheduledTaskLog"}
                                                        />

                                                    )
                                                }) : !loadingDetail && <p style={{ margin: 0 }}>{messages["entityDetails_attachmentsNotFound"]}</p>}
                                            </Container>
                                        </TabContainer>
                                    </Tabs>
                                )
                        }
                    </div>
                    <NotificationContainer />
                </Modal>
            }
            <Modal
                size="small"
                open={openModalDelete}
                handleClose={handleCloseDelete}
                title={`${numberTab === 0 ? messages['entityDetails_titleDeleteSubscriber'] : messages['entityDetails_titleDeleteAttachment']}`}
                footer={(
                    <div>
                        <Button
                            id={'btn-cancel-vehicle'}
                            onClick={() => handleCloseDelete()}
                            variant="secondary"
                            style={{ marginRight: "5px" }}
                        >
                            {messages['cancel']}
                        </Button>

                        <Button
                            id={'btn-schedule'}
                            variant="warning"
                            onClick={() => handleDeleteAttachmentSubmit()}
                        >
                            {messages['delete']}
                        </Button>
                    </div>
                )}
            >
                <div style={{ padding: '0px 25px' }}>
                    <p style={{ overflowWrap: 'anywhere' }}>
                        {numberTab === 0 ? messages['entityDetails_deleteSubscriber'] : messages['entityDetails_deleteAttachment']}
                        {`"${currentAttachmentTitle && currentAttachmentTitle}"?`}
                    </p>
                </div>
                <NotificationContainer />
            </Modal>
        </Fragment>
    );
};

export default EntityDetails;